<template>
<v-container fluid >
    <h1 class="d-flex justify-center textTitle--text font-weight-black">{{ $t('views.database.screenTitle') }}</h1>
    <v-row justify="center" class="ma-5 pa-5 secondary">
    <v-btn @click="deleteDb" large class="error ma-3 pa-3 text-h4 font-weight-black black--text">{{ $t('views.database.eraseButton') }}</v-btn>
    </v-row>
    <v-row class="justify-center pa-5 ma-5">
    <v-card elevation="11" class="ma-3 pa-3 primary" width="70%">

<v-row class="justify-center pa-5 ma-5"> 
 <h3 class="quinty--text text-center ">{{ $t('views.database.keepMessage') }}</h3>
</v-row>
<v-row class="justify-center pa-5 ma-5" width="50%">
  <v-btn @click="saveDb2" x-large class="success text-h4 font-weight-black black--text pa-5">{{ $t('views.database.keepButton') }}</v-btn>
</v-row>
<v-row class="justify-center pa-5 ma-5">
 <h3 class="quinty--text text-center ">{{ $t('views.database.keepMessage2') }}</h3>
</v-row>
<v-dialog :retain-focus='false' width="550px" v-model="confirmSaveDb">
              <successMessage @close="confirmSaveDb=false" :title="'Confirmacion'" :message="$t('views.database.confirmMessage')+namefile" :key="confirmSaveKey"/>
            </v-dialog>     
    </v-card>
    </v-row>

    <v-row class="justify-center pa-5 ma-5">
    <v-card elevation="11" class="ma-3 pa-3 primary" width="70%">

<v-row class="justify-center pa-5 ma-5"> 
 <h3 class="quinty--text text-center ">{{ $t('views.database.getMessage') }}</h3>
</v-row>
<v-row class="justify-center pa-5 ma-5" width="50%">
  <v-btn @click="readDb2" x-large class="info text-h4 font-weight-black black--text pa-5">{{ $t('views.database.getButton') }}</v-btn>
</v-row>

<v-dialog :retain-focus='false' width="550px" v-model="confirmReadDb">
              <successMessage @close="confirmReadDb=false" :title="'Confirmacion'" :message="'Cargada la base de datos del archivo : '+namefile" :key="confirmReadKey"/>
            </v-dialog>  
            <v-dialog :retain-focus='false' width="550px" v-model="confirmDeleteDial">
              <confirmMessage @confirm="clearProductDb" @close="confirmDeleteDial=false" :title="$t('confirm')" :message="$t('views.database.messageDeleteDb')" :key="confirmDeleteDialKey"/>
            </v-dialog>    
    </v-card>
    </v-row>
    
</v-container>
</template>

<script>
import successMessage from '@/components/successMessage'
import confirmMessage from '@/components/confirmMessage'


    function writeToFileSync(filepath, content) {
      if (window && window.require) {
        const fs = window.require('fs')
        var mkdirp = require('mkdirp');
        
        var getDirName = require('path').dirname;

        
          mkdirp(getDirName(filepath), async function (err) {
            if (err) return console.log(err);

            //console.log(filepath)
            await fs.writeFileSync(filepath, JSON.stringify(content))
          });
        }
      }

      
    function readFileSync(filepath) {
      //console.log(filepath)
      if (window && window.require) {
        const fs = window.require('fs')
          var data = fs.readFileSync(filepath, 'utf8')
          //console.log(data)
          var json = JSON.parse(data)
          return json
      }}




          
export default {
  components:{successMessage,confirmMessage},
    data () {
        return {
            confirmSaveDb:false,
            confirmSaveKey:0,
            namefile:'',
            confirmReadDb:false,
            confirmReadKey:0,
            confirmDeleteDial:false,
            confirmDeleteDialKey:0,


        }

    },
    computed:{

    },
    mounted() {
            
        },
    methods:{
      deleteDb(){
        this.confirmDeleteDialKey+=1
        this.confirmDeleteDial=true
      },
      clearProductDb(){
        this.$store.dispatch('eraseDb')
        this.confirmDeleteDial=false
      },
      saveDb2(){
        if(process.platform!='browser'){
        if (typeof (process.versions.electron) === 'string') {
                // Electron specific code
                const current_datetime = new Date();
                let date = current_datetime.getDate() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getFullYear()+ "-" + current_datetime.getHours()+ "h" + current_datetime.getMinutes()
                //console.log(formatted_date)
                const filenName = this.$t('views.database.fileName')+date.toLocaleString()+'.json';
                const defaultPath = this.$app.getPath('documents') +'/'+ this.$t('views.database.folderName')+'/'+filenName;
                
                const content = this.$db.get();
                //console.log(content)

                writeToFileSync(defaultPath, content)

                this.namefile=filenName;
                this.confirmSaveKey+=1;
                this.confirmSaveDb=true;
        }}else{
          alert(this.$t('views.database.messagePremium'))
        }
        
      },
      readDb2(){
        if(process.platform!='browser'){
        if (typeof (process.versions.electron) === 'string') {
                // Electron specific code
                var filePath
                var json 
                var name
                this.$dialog.showOpenDialog( {
                  properties: ['openFile']
                }).then(result => {
                  //console.log(result.canceled)
                  filePath=result.filePaths
                  if(!filePath){alert(this.$t('views.database.errorFolder'))}
                else{
                  json = readFileSync(filePath[0])
                  name = filePath[0].split("/")
                }
                if(json){
                  this.$db.delete()
                  this.$db.set(json)
                  this.$store.dispatch('loadElectronDb')
                  var size = name.length
                  this.namefile=name[size-1];
                this.confirmReadKey+=1;
                this.confirmReadDb=true;
                }
                }).catch(err => {
                  console.log(err)
                })
        }}else{
         alert(this.$t('views.database.messagePremium'))
        }
        
        
        
      }
      

    }
}
</script>